
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[ssgParams]/store/products/[slug]",
      function () {
        return require("private-next-pages/[ssgParams]/store/products/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[ssgParams]/store/products/[slug]"])
      });
    }
  